<template>
  <div class="linkFormSectionWrap">
    <unlock-card
      ref="unlockForm"
      :unlock-data="unlockData"
      :show-completion-status="showCompletionStatus"
      :completion-done="completionDone"
    />
  </div>
</template>

<script>
import unlockCard from '../../unlockCard.vue'

export default {
  name: 'GenericResourceUnlockSection',
  components: { unlockCard },
  props: {
    unlockData: { type: Object, required: true },
    showCompletionStatus: { type: Boolean, default: false },
    completionDone: { type: Boolean, default: false },
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        if (!this.$refs.unlockForm) {
          resolve()
          return
        }
        this.$refs.unlockForm.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject('请完善解锁组配置')
          }
        })
      })
    },
    captureSnapshot() {
      return JSON.parse(JSON.stringify(this.unlockData))
    },
  },
}
</script>
